<template>
  <w-modal
    v-model="show"
    submit-button="Zamknij"
    title="Eksport listy do CSV"
    class="modal-big"
    :show-footer="false"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="close"
    @close="close"
  >
    <div class="row">
      <div class="col-12 mb-5">
        <w-button class="btn btn-light mr-3" text="Zaznacz wszystkie" @click="selectAll" />

        <w-button class="btn btn-light" text="Odznacz wszystkie" @click="unselectAll" />
      </div>

      <div v-for="(prop, propIndex) of properties" :key="'prop_' + propIndex" class="col-md-6">
        <w-checkbox :model="$schema.props" :title="getTitle(prop)" :value="prop.path" />
      </div>

      <div class="col-12">
        <w-button class="float-left btn btn-secondary" text="Zamknij" @click="$emit('close')" />

        <post-form text="Eksportuj" class="float-right" button-class="btn btn-primary" :url="url" :fields="fields" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { flatPropsList } from '@witkac/jschema';
import { mapState } from 'vuex';

import PostForm from '@/components/postForm/PostForm';
import { formMixin } from '@/mixins/form';
import { modalMixin } from '@/mixins/modal';
import schema from '@/schemas/csvGenerate.schema';

// @vuese
// Modal generowania CSV
export default {
  components: { PostForm },
  mixins: [formMixin, modalMixin],
  schema,
  props: {
    // Url do pobrania CSV
    url: { type: String, required: true },
    // Filtry
    documentIds: { type: Array, required: false }
  },
  data() {
    return { model: {} };
  },
  computed: {
    ...mapState({
      properties: state => {
        if (state.schema.data?.schema) {
          const currentSchema = JSON.parse(state.schema.data?.schema);
          const ignoredList = flatPropsList(currentSchema)
            .filter(prop => prop.schema.csv && prop.schema.csv.ignore)
            .map(prop => prop.path.replace(/\[\]/g, ''));

          const props = flatPropsList(currentSchema, true)
            .map(prop => ({ ...prop, path: prop.path.replace(/\[\]/g, '') }))
            .filter(
              prop =>
                !prop.schema.computed &&
                (!prop.schema.csv || !prop.schema.csv.ignore) &&
                !ignoredList.some(ignoredPath => prop.path.includes(ignoredPath))
            );
          props.unshift({ path: 'documentId', field: 'documentId', schema: { title: 'Identyfikator' } });
          return props.map(prop => ({ ...prop, path: prop.path.replace(/.items$/g, '') }));
        }
        return [];
      }
    }),
    fields() {
      return [
        { name: 'documentIds', value: this.documentIds && JSON.stringify(this.documentIds) },
        { name: 'props', value: this.$schema.props.$getData() }
      ];
    }
  },
  methods: {
    // @vuese
    // Pobiera tytuł property schemy
    getTitle(prop) {
      const parent =
        prop.schema.$parent?.type === 'array' ? prop.schema?.$parent?.$parent?.$parent : prop.schema?.$parent?.$parent;
      const propTitle =
        prop.schema.$parent?.type === 'array'
          ? prop.schema.$parent.csv?.title || prop.schema.$parent.title || prop.path
          : prop.schema.csv?.title || prop.schema.title || prop.path;

      if (!(parent?.csv?.title || parent?.title)) {
        return propTitle;
      }

      return (parent.csv?.title || parent.title) + ' - ' + propTitle;
    },

    // @vuese
    // Zaznacza wszystkie elementy
    selectAll() {
      this.$schema.props.$setData(
        this.properties.map(prop => prop.path),
        undefined,
        true
      );
    },

    // @vuese
    // Odznacza wszystkie elementy
    unselectAll() {
      this.$schema.props.$setData([], undefined, true);
    }
  }
};
</script>
